<template>
	<main>
		<crumbs :crumbs="crumbs"></crumbs>
		<div class="wrap">
			<div class="title-box">
				<div class="title">解决方案精选</div>
				<div class="min-title">大会精彩内容抢先观看，为您解读不同解决方案的打开方式。</div>
			</div>
			<div class="category">
				<div class="swiper-container" id="swiper-category">
					<div class="swiper-wrapper">
						<div class="swiper-slide" v-for="(item,index) in category_list" @click="chooseCategory(item,index)">
							<div class="item" :style="{backgroundImage:'url('+util.autoImage((category.id == item.id ? item.bg : item.bg2))+')'}" :class="[category.id == item.id ? 'active' : '']" >
								<div class="cen">
									<div class="middle">
										<div class="icon"><img :src="util.autoImage(item.icon)" alt=""></div>
										<div class="icon icon-a"><img :src="util.autoImage(item.icon2)" alt=""></div>
										<div class="tit">{{item.title}}</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="list">
				<div class="item" v-for="(item,index) in video_list" @click="showVideo(item)">
					<div class="image-box">
						<div class="image" :style="{backgroundImage:'url('+(item.image ? util.autoImage(item.image): util.autoImage(item.video)+'?x-oss-process=video/snapshot,t_0,f_jpg,m_fast')+')'}"><div class="play"></div></div>
					</div>
					<div class="info">
						<div class="tit">{{item.category_title}}</div>
						<div class="element-more min-tit
">{{item.title}}</div>
					</div>
				</div>
			</div>
			<div class="empty" v-if="video_list.length <= 0">暂无数据</div>
			<div class="banner" @click="toBanner" v-if="banner.id" :style="{backgroundImage:'url('+util.autoImage(banner.image)+')'}"></div>
		</div>
		<video-float v-if="video_info.title" :video_info="video_info" @hideVideo="hideVideo"></video-float>
	</main>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import 'swiper/dist/css/swiper.css'
import Crumbs from "../../components/m/Crumbs";
import Loading from "../../components/m/Loading";
import VideoFloat from "../../components/m/VideoFloat";
export default {
	name: 'my-video',
	data() {
		return {
			query:"",
			category_list:[],
			category:{},
			video_list:[],
			one:{},
			data_loading:true,

			video_info:{},
			s1_play_show:true,

			banner:{}
		}
	},
	components:{
		Crumbs,Loading,swiper,swiperSlide,VideoFloat
	},
	computed:{
		crumbs() {
			return {title:"解锁超多精彩内容",min_title:"SNEAK PEEK"}
		},
	},
	methods: {
		toBanner(){
			if(this.banner.link){
				window.open(this.banner.link);
			}else{
				this.util.showWait(true)
			}
		},
		getAdv(){
			this.http.request({
				api:"adv/getAdv",
				data:{
					position:2,
				},
				success:(res)=>{
					this.banner = res.adv[0];
				}
			})
		},
		showVideo(item){
			gio('track', 'DTF2021_videoclick',{
				DTF2021_videotitle:item.title,
			});

			item.video = item.url;
			this.video_info = item;
		},
		hideVideo(){
			this.video_info = {}
		},
		swiperInit(){
			this.swiper = new Swiper('#swiper-category',{
				slidesPerView:this.category_list.length > 3 ? 3.5 : 3,
				spaceBetween: 15,
				slidesOffsetAfter:2,
				watchOverflow:true,
				slideToClickedSlide:true,
				observer:true,
				observeSlideChildren:true,
			})
		},
		chooseCategory(item,index){
			this.category = item;
			this.getVideoList();
		},
		getVideoList(){
			this.http.request({
				api:"video/getVideoList",
				data:{
					video_category_id:this.category.id
				},
				success:(res)=>{
					this.video_list = res.list;
					this.one = res.list && res.list.length > 0 ? res.list[0] : {};
					this.data_loading = false;
					this.$nextTick(()=>{
						this.util.showBottom(true);
					})
				}
			})
		},
		getCategoryList(){
			this.http.request({
				api:"video/getCategoryList",
				success:(res)=>{
					this.category_list = res.category;
					this.category = res.category[0];
					this.getVideoList();
					this.$nextTick(()=>{
						this.swiperInit();
					})
				}
			})
		}
	},
	mounted() {
		this.query = this.$route.query;
		this.getCategoryList();
		this.getAdv();
	}
}
</script>

<style lang="scss" type="text/scss" scoped>
.wrap{background:#f6f6f6 url("~@/assets/image/2021/17_m.png") no-repeat bottom center;background-size:100% auto;padding:.4rem;
	.title-box{padding-left: 30px;background: url("~@/assets/image/2021/10.png") no-repeat left top;background-size: 100px;text-align: left;
		.title{font-size:.48rem;line-height:.64rem;color:#376f84;}
		.min-title{font-size:.24rem;color:#444;margin-top:.18rem;line-height: .36rem;}
	}
	.category{margin-top: .4rem;
		.swiper-container{padding: .1rem ;
			.item{height:1.2rem;box-shadow: 0 0 .1rem .02rem rgba(0,0,0,.1); position: relative;cursor: pointer;text-align: center;transition: all .3s ease;
				.cen{display: inline-block;
					.middle{text-align: center;transition: all .3s ease;height:1.2rem;
						.icon{width:.58rem;height:.41rem;margin: 0 auto;
							img{display: block; width: 100%;height:100%;object-fit: contain;}
						}
						.icon-a{display: none;margin: 0 auto;}
						.tit{color:#333;font-size:.24rem;line-height:.31rem;margin-top: .1rem;padding: 0 .2rem;}
					}
				}
			}
			.item.active{transition: all .3s ease;background: url("~@/assets/image/b44.jpg") no-repeat center center;background-size: cover;
				.cen{
					.middle{
						.icon{display: none;}
						.icon-a{display: block;}
						.tit{color:#fff;}
					}
				}
			}
			.item:nth-last-child(1){margin-right: 0;}
		}
	}
	.list{margin-top: .4rem;overflow:hidden;
		.item{float: left;width:3.09rem;margin-right:.3rem;text-align: left;transition: all .3s ease;background: #fafafa;box-shadow: 0 0 .1rem .02rem rgba(0,0,0,.1);margin-bottom: .3rem;
			.image-box{
				.image{height:1.72rem;background:url("~@/assets/image/11.png") no-repeat center center;background-size: cover;position: relative;
					.play{width: .5rem;height:.5rem;position: absolute;top:50%;left:50%;background: url("~@/assets/image/2021/7.png") no-repeat left center;background-size: contain;margin-left: -.25rem;margin-top: -.25rem; cursor: pointer;z-index: 2;}
				}
				.image::after{content: "";display: block;position: absolute;top:0;left:0;width: 100%;height:100%; background: rgba(0,0,0,.5);z-index: 1;}
			}
			.info{padding:.2rem;box-sizing: border-box;
				.tit{font-size: .22rem;line-height: .3rem;color:#1D56C0 ;
					i{font-weight: bold;margin-left: .05rem;}
				}
				.min-tit{font-size:.24rem;color:#666666;line-height:.33rem;min-height:.66rem; -webkit-line-clamp: 2;}
			}
		}
		.item:nth-child(2n){margin-right: 0;}
	}
	.tips { font-size:14px; padding-bottom: 50px;text-align: left;color:#999;width: 1200px;margin: 0 auto;
		i{color:red;}
	}
	.banner{width:6.66rem;height:2.36rem;background: url("~@/assets/image/2021/26.png") no-repeat center center;background-size: contain; margin:.3rem auto 0;cursor:pointer;overflow:hidden;}
}
</style>

